import { atom } from 'jotai'

// 無料リサーチのモーダル開閉用
export const researchModal = atom(false)

// 下書きリサーチ編集用
export const draftResearchNo = atom(null)

